import { WIDGETBASE_CLASS } from 'constants/bounding-box';
import { PAGE_CONTAINER_CLASSNAME } from 'modules/Editor/Editor.config';
import { WidgetType } from 'types/widget.types';
import { LineWidgetTypes } from 'widgets/Lines/LineWidget/LineWidget.types';
import { RESPONSIVE_WIDGET_LIST } from 'widgets/Widget.config';

export const MUTATION_OBSERVER_CONFIG = {
  attributes: true,
  attributeFilter: ['style'],
  childList: false,
  subtree: false,
};

export const MUTATION_OBSERVER_CONFIG_WITH_SUBTREE = {
  ...MUTATION_OBSERVER_CONFIG,
  childList: true,
  subtree: true,
  characterDataOldValue: true,
};

export const OBSERVING_SUBTREE_WIDGET_LIST = [
  WidgetType.Table,
  WidgetType.Text,
  WidgetType.Group,
  ...RESPONSIVE_WIDGET_LIST,
];

/**
 * NodeCreatorModal config
 */
export const PADDING_PX = 30;
export const BUTTON_GRID_PX = 60;
export const BUTTON_GRID_GAP = 4;
export const BUTTON_GRID_WIDGET_PADDING_PX = 5;
export const BUTTON_GRID_WIDGET_PX = BUTTON_GRID_PX - BUTTON_GRID_WIDGET_PADDING_PX * 2;

export const FLOW_MODE_WIDGET_SELECTOR_CLASS = `.${PAGE_CONTAINER_CLASSNAME} .${WIDGETBASE_CLASS}`;

/**
 * Widgets that use the stepped line algorithm
 */
export const STEPPED_LINE_TYPES = [LineWidgetTypes.curved, LineWidgetTypes.stepped];
